module.exports = __webpack_public_path__ + "static/13-Koi-Pound-1cfbaf831991f5207abdea6eaaae59cb.jpeg";